import { Box, Input, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import React from "react";

interface FileDropZoneProps {
  isDragging: boolean;
  selectedFolder: { id: string; name: string } | null;
  selectedFiles: File[] | null;
  fileInputRef: React.RefObject<HTMLInputElement>;
  onBoxClick: () => void;
  onDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
  onDragLeave: (e: React.DragEvent<HTMLDivElement>) => void;
  onDrop: (e: React.DragEvent<HTMLDivElement>) => void;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FileDropZone: React.FC<FileDropZoneProps> = ({
  isDragging,
  selectedFolder,
  selectedFiles,
  fileInputRef,
  onBoxClick,
  onDragOver,
  onDragLeave,
  onDrop,
  onFileChange,
}) => {
  const { t } = useTranslation("common");

  return (
    <Box
      border="2px dashed"
      borderColor={isDragging ? "blue.400" : "gray.300"}
      borderRadius="md"
      py={10}
      textAlign="center"
      color="gray.500"
      mb={4}
      cursor="pointer"
      bg={isDragging ? "blue.50" : "transparent"}
      transition="all 0.2s"
      onClick={onBoxClick}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      _hover={{ borderColor: "blue.300", bg: "gray.50" }}
    >
      <Text>{t("projects.dragDrop")}</Text>
      <Text fontSize="sm" color="gray.500">
        {t("projects.in")}{" "}
        {selectedFolder?.name ?? t("projects.folderNamePlaceholder")}{" "}
        {t("projects.folder")}
      </Text>
      {selectedFiles?.length ? (
        <Text fontSize="sm" color="blue.500" mt={2} fontWeight="medium">
          {selectedFiles.length}{" "}
          {selectedFiles.length === 1
            ? t("projects.file")
            : t("projects.filesLabel")}{" "}
          {t("projects.selected")}
        </Text>
      ) : null}
      <Input
        ref={fileInputRef}
        type="file"
        multiple
        onChange={onFileChange}
        display="none"
      />
    </Box>
  );
};

export default FileDropZone;

